export default __webpack_public_path__ + "static/media/a3.84649282.JPG";